// @flow
import * as React from 'react';
import styled from 'styled-components';
import LoaderContainer from './LoaderContainer';

const StyledContainer = styled.div`
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.75);

  opacity: ${props => props.isLoading ? 1 : 0};
  animation: ${props => props.isLoading ? 'fadeIn' : 'fadeOut'} ease ${props => (props.isLoading || (props.animationEnabled && !props.isLoading)) ? 300 : 0}ms;
  z-index: ${props => props.isLoading ? 11111 : -1};

  @keyframes fadeIn {
    0% {
      opacity: 0;
      z-index: -1;
    }
    100% {
      opacity: 1;
      z-index: 111111;
    }
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
      z-index: 111111;
    }
    100% {
      opacity: 0;
      z-index: -1;
    }
  }
`;


type TProps = {
  animationEnabled: boolean,
  isLoading: boolean,
  children: ?React.Node,
};

export default function LoaderOverlay(props: TProps): React.Node {
  return [
    <StyledContainer key="loader" isLoading={props.isLoading} animationEnabled={props.animationEnabled}>
      <LoaderContainer size={45} isLoading={props.isLoading} />
    </StyledContainer>,
    props.children,
  ];
}

